/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { jsx } from '@atlaskit/css';
import { Box, Stack } from '@atlaskit/primitives/compiled';

type FormSectionProps = {
	children: React.ReactNode;
};

/**
 * __Form section__
 *
 * A section within the appearance controls form, with optional border.
 */
const FormSection = ({ children }: FormSectionProps) => {
	return (
		<Box>
			<Stack space="space.150">{children}</Stack>
		</Box>
	);
};

export default FormSection;
